import React from 'react'
import ReactDOM from 'react-dom/client'
import { WrappedApp } from './App'
import { logger } from './utils/logger'
import './index.css'

// Global error handlers — reportar todos los errores no capturados a New Relic
window.addEventListener('error', (event) => {
  if (
    event?.message?.includes('Loading chunk') ||
    event?.message?.includes('ChunkLoadError')
  ) {
    window.location.reload()
    return
  }

  logger.logError(event.error ?? event.message, {
    type: 'unhandled_error',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno
  })
})

window.addEventListener('unhandledrejection', (event) => {
  if (event?.reason?.name === 'ChunkLoadError') {
    window.location.reload()
    return
  }

  const error =
    event.reason instanceof Error
      ? event.reason
      : new Error(String(event.reason))

  logger.logError(error, {
    type: 'unhandled_promise_rejection'
  })
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <WrappedApp />
  </React.StrictMode>
)
